(function () {
    'use strict';

    angular.module("imApp").factory("tailorAccessesService", ['$ihttp', function ($ihttp) {
        let service = {
            listTailorAccesses: function (parms) {
                return $ihttp.post({
                    method: 2094,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
